import { render, staticRenderFns } from "./AppointmentBooked.vue?vue&type=template&id=4c547ce1"
import script from "./AppointmentBooked.vue?vue&type=script&lang=js"
export * from "./AppointmentBooked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports